import { axiosInstance, axiosInstanceNoToken } from "./axiosConfig";
import { isAxiosError } from "axios";
import Cookies from 'js-cookie';
import { setAccessToken } from "./axiosConfig";

//INTERFACE_REQUEST_LOGIN
interface LoginRequests {
    phone_number: string;
    pin: string;
    personal_info_consent: boolean;
}

//INTERFACE_SUCCESS_LOGIN
interface LoginSuccessResponse {
    phone_number: string;
    message?: string;
}
//Validation_ERROR_LOGIN
interface ErrorDetail {
    code: string;
    detail: string;
    attr: string;
}

//Generic Error Response_LOGIN
interface GenericErrorResponse {
    error?: string;
}

//INTERFACE_ERROR_LOGIN
interface LoginErrorResponse {
    type: 'validation_error';
    errors: ErrorDetail[];
}

//INTERFACE_RESULT_LOGIN
interface LoginResult {
    data: LoginSuccessResponse | LoginErrorResponse | GenericErrorResponse;
    status: number,
}

//OTP_REQUEST
interface OtpRequest {
    phone_number: string;
    otp_code: string;
}
interface ValidationError {
    code: string;
    detail: string;
    attr: string;
}

interface OtpErrorResponse {
    type?: string;
    error?: string;
    errors?: ValidationError[];
    [key: string]: any;
}

interface OtpSuccessResponse {
    access?: string;
    refresh?: string;
    access_token?: string;
    refresh_token?: string;
}
interface OtpResult {
    data: OtpSuccessResponse | OtpErrorResponse;
    status: number;
    success: boolean;
}

// RESEND_OTP_REQUEST
interface ResendOtpRequest {
    phone_number: string;
}

// RESEND_OTP_SUCCESS_RESPONSE
interface ResendOtpSuccessResponse {
    phone_number: string;
    message?: string;
}

// RESEND_OTP_ERROR_RESPONSE
interface ResendOtpErrorResponse {
    type?: string;
    error?: string;
    errors?: ValidationError[];
    [key: string]: any;
}

// RESEND_OTP_RESULT
interface ResendOtpResult {
    data: ResendOtpSuccessResponse | ResendOtpErrorResponse;
    status: number;
    success: boolean;
}


// DIGITAL_LOGIN_SUCCESS_RESPONSE
interface DigitalLoginSuccessResponse {
    login_url: string;
    message?: string;
}

// DIGITAL_LOGIN_ERROR_RESPONSE
interface DigitalLoginErrorResponse {
    type?: string;
    error?: string;
    errors?: ValidationError[];
    [key: string]: any;
}

// DIGITAL_LOGIN_RESULT
interface DigitalLoginResult {
    data: DigitalLoginSuccessResponse | DigitalLoginErrorResponse;
    status: number;
    success: boolean;
}

// TOKEN REFRESH INTERFACES
interface RefreshTokenRequest {
    refresh: string;
}

interface RefreshTokenSuccessResponse {
    access: string;
    refresh?: string;
}

interface RefreshTokenErrorResponse {
    type?: string;
    error?: string;
    errors?: ValidationError[];
    [key: string]: any;
}

interface RefreshTokenResult {
    data: RefreshTokenSuccessResponse | RefreshTokenErrorResponse;
    status: number;
    success: boolean;
}

// TOKEN REFRESH API
export const RefreshTokenCustomer = async (
    refresh_token: string,
): Promise<RefreshTokenResult> => {
    try {

        const requestBody: RefreshTokenRequest = {
            refresh: refresh_token
        };

        const response = await axiosInstance.post<RefreshTokenSuccessResponse>(
            '/auth/token/refresh',
            requestBody,

        );

        return {
            data: response.data,
            status: response.status,
            success: true
        };

    } catch (error) {
        if (isAxiosError(error)) {
            // HTTP ERROR
            if (error.response) {
                return {
                    data: error.response.data || { error: 'Token yeniləmə xətası baş verdi' },
                    status: error.response.status,
                    success: false
                };
            }

            // Network error
            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0,
                    success: false
                };
            }
        }

        // Another error
        return {
            data: {
                error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
            },
            status: -1,
            success: false
        };
    }
};

// DIGITAL LOGIN API
export const DigitalLoginCustomer = async (
    phone_number: string,
): Promise<DigitalLoginResult> => {
    try {
        const client_id = process.env.REACT_APP_CLIENT_ID;

        const response = await axiosInstance.get<DigitalLoginSuccessResponse>(
            `/auth/digital_login/login?client_id=${client_id}`,
            {
                params: {
                    phone_number
                },

            }
        );


        return {
            data: response.data,
            status: response.status,
            success: true
        };

    } catch (error) {
        if (isAxiosError(error)) {
            // HTTP ERROR
            if (error.response) {
                return {
                    data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
                    status: error.response.status,
                    success: false
                };
            }

            // Network error
            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0,
                    success: false
                };
            }
        }

        // Another error
        return {
            data: {
                error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
            },
            status: -1,
            success: false
        };
    }
};

// RESEND OTP API
export const ResendOtpCustomer = async (
    phone_number: string,
): Promise<ResendOtpResult> => {
    try {
        console.log(phone_number)
        const requestBody: ResendOtpRequest = {
            phone_number
        };

        const response = await axiosInstance.post<ResendOtpSuccessResponse>(
            '/auth/send_otp',
            requestBody

        );

        return {
            data: response.data,
            status: response.status,
            success: true
        };

    } catch (error) {
        if (isAxiosError(error)) {
            // HTTP ERROR
            if (error.response) {
                return {
                    data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
                    status: error.response.status,
                    success: false
                };
            }

            // Network error
            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0,
                    success: false
                };
            }
        }

        // Another error
        return {
            data: {
                error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
            },
            status: -1,
            success: false
        };
    }
};

// OTP  API
export const VerifyOtpCustomer = async (
    phone_number: string,
    otp_code: string,
): Promise<OtpResult> => {
    try {

        // Determine endpoint based on login flow:
        // - MyGov flow (currentUserId exists): uses /auth/verify_otp (requires bearer token)
        // - Standard FIN/phone flow: uses /auth/token (no token needed)
        const isMyGovFlow = !!localStorage.getItem('currentUserId');
        const endpoint = isMyGovFlow ? '/auth/verify_otp' : '/auth/token';

        const requestBody: OtpRequest = {
            phone_number,
            otp_code
        };

        const response = await axiosInstance.post<OtpSuccessResponse>(
            endpoint,
            requestBody,

        );
        const access = response.data.access || response.data.access_token;
        const refresh = response.data.refresh || response.data.refresh_token;

        if (access) {
            setAccessToken(access);
        }
        if (refresh) {
            Cookies.set('refreshToken', refresh, {
                secure: process.env.NODE_ENV === 'production',
                sameSite: 'strict',
                path: '/'
            });
        }
        return {
            data: response.data,
            status: response.status,
            success: true
        };

    } catch (error) {
        if (isAxiosError(error)) {
            // HTTP ERROR
            if (error.response) {
                return {
                    data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
                    status: error.response.status,
                    success: false
                };
            }

            // Network error
            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0,
                    success: false
                };
            }
        }

        // Another error
        return {
            data: {
                error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
            },
            status: -1,
            success: false
        };
    }
};

//LOGIN
export const LoginCustomer = async (
    phone_number: string,
    pin: string,
): Promise<LoginResult> => {
    try {
        const requestBody: LoginRequests = {
            phone_number,
            pin,
            personal_info_consent: true,
        };

        const response = await axiosInstanceNoToken.post<LoginSuccessResponse>(
            '/auth/login',

            requestBody,


        );

        return {
            data: response.data,
            status: response.status
        };
    } catch (error) {
        if (isAxiosError(error)) {
            //HTTP ERROR
            if (error.response) {
                return {
                    data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
                    status: error.response.status
                };
            }
            //Network error
            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0
                }
            }
        }

        //Another error
        return {
            data: { error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi' },
            status: -1
        }
    }
}